import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { SortsPropType, columnConfigPropType } from '../Table/propTypes';
import { TABLE_SETTING } from '../../constants/Tables';
import { makeColumnTranslation } from '../../utils/table';
import { renderablePropType } from '../../utils/propTypes';
import { ORDER_LIST_ROW_FIELDS } from '../../apis/hooks/models/orderList';
import NoResults from '../NoResults';
import Table from '../Table';

function OrdersTable({
	orders = [],
	total = 0,
	sorts,
	onSort,
	onPageChange,
	pagination = { limit: TABLE_SETTING.DEFAULT_PAGE_SIZE, page: 0 },
	columnConfig,
	columnOrder,
	columnVisibility,
	isLoading,
	children,
}) {
	const { t } = useTranslation('orders');
	const columnT = makeColumnTranslation(t, 'columns');
	const navigate = useNavigate();

	return (
		<Table
			items={orders}
			columnConfig={columnConfig}
			noResultsContent={<NoResults>orders</NoResults>}
			renderColumnHeader={(key) => columnT(key)}
			TableRowProps={({
				[ORDER_LIST_ROW_FIELDS.ORDER_NUMBER]: orderNumber,
				[ORDER_LIST_ROW_FIELDS.SOURCE]: source,
			}) => ({
				hover: true,
				style: { cursor: 'pointer' },
				onClick: () => navigate(`/orders/${orderNumber}/${source}`),
				key: orderNumber,
			})}
			columnOrder={columnOrder}
			columnVisibility={columnVisibility}
			isLoading={isLoading}
			pagination={pagination}
			total={total}
			sorts={sorts}
			onSort={onSort}
			onPageChange={onPageChange}
		>
			{children}
		</Table>
	);
}

OrdersTable.propTypes = {
	orders: PropTypes.array,
	total: PropTypes.number,
	sorts: SortsPropType,
	onSort: PropTypes.func,
	onPageChange: PropTypes.func.isRequired,
	pagination: PropTypes.shape({
		limit: PropTypes.number.isRequired, // rows per page
		page: PropTypes.number.isRequired, // current page
	}),
	columnConfig: columnConfigPropType,
	columnOrder: PropTypes.array.isRequired,
	columnVisibility: PropTypes.object.isRequired,
	isLoading: PropTypes.bool,
	children: renderablePropType,
};

export default OrdersTable;
